// ============================================================
// DESIGN TOKENS — edit here to restyle the whole app.
// ============================================================

// Color palette
export const C = {
  bg:"#0a0e14", bgC:"#10151e", bgH:"#161c26",
  bd:"#1f2937", bdL:"#2a3441",
  tx:"#e5e7eb", txD:"#9ca3af", txM:"#6b7280",
  ac:"#fbbf24",  acD:"rgba(251,191,36,.12)",
  bl:"#60a5fa", blD:"rgba(96,165,250,.12)",
  gn:"#34d399", gnD:"rgba(52,211,153,.12)",
  rd:"#f87171", rdD:"rgba(248,113,113,.12)",
  pu:"#c084fc", puD:"rgba(192,132,252,.12)",
  am:"#f59e0b", amD:"rgba(245,158,11,.12)",
  cy:"#22d3ee",
};

// Font sizes — named by role.
// Increase/decrease all sizes by editing these values.
export const F = {
  xxs: 10,   // barely-there: chart axis ticks, small annotations
  xs:  11,   // meta labels, ALL-CAPS headers
  sm:  12,   // secondary text, tooltip rows
  md:  13,   // body text
  lg:  14,   // primary text, inputs
  xl:  15,   // medium emphasis
  h3:  16,   // sub-headings
  h2:  18,   // section headings
  h1:  20,   // page headings (rare)
  d2:  22,   // display medium — rate/spread panels
  d1:  26,   // display large — hero spot number
};

// Font families
export const MONO = "'IBM Plex Mono', monospace";
export const SANS = "'IBM Plex Sans', -apple-system, sans-serif";
